module.exports = __webpack_public_path__ + "img/gray-plus-icon.03a1fa70.svg";